import Vue from 'vue'
import App from './App.vue'

import { BootstrapVue, IconsPlugin } from "bootstrap-vue";
import "bootstrap/dist/css/bootstrap.css";
import "bootstrap-vue/dist/bootstrap-vue.css";

import VueRouter from "vue-router";
import { routes } from "./routes";
import { store } from "./store/store";
import Vuetify from "vuetify";

import VueLodash from "vue-lodash";
import lodash from "lodash";

import firebase from "firebase/app";

import VueAnalytics from "vue-analytics";

import Embed from "v-video-embed";
Vue.use(Embed);


Vue.config.productionTip = false;

// alias
Vue.prototype.$analytics = firebase.analytics();



Vue.use(VueAnalytics, {
  id: "G-TQBF9D58WC",
  router,
  autoTracking: {
    screenview: true,
  },
});

Vue.use(require("vue-moment"));


Vue.use(VueLodash, { lodash: lodash });


Vue.use(VueRouter);
Vue.use(Vuetify);




const router = new VueRouter({
  routes,
  mode: "history",
  scrollBehavior(to) {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  },
});

// Install BootstrapVue
Vue.use(BootstrapVue)
// Optionally install the BootstrapVue icon components plugin
Vue.use(IconsPlugin)
new Vue({

  router,
  store,
  render: (h) => h(App),
}).$mount("#app");

